// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202606171335/js/" + chunkId + "." + {"44":"6c9a2ceb","225":"35b3e703","481":"fd0c2eed","486":"fa4bcf7c","770":"8e0e6923"}[chunkId] + ".0.9283521040181874.chunk.js";
};